export default {
  common: {
    siteTitle: "Epitaph - LuobeiLetters Works Collection",
    siteDescription: "Hope everyone can find their own ideals and work for them. LuobeiLetters' portfolio of games, novels, and artwork. (formerly tobenot)",
    nav: {
      home: "Home",
      about: "Epitaph",
      blog: "Blog (Thoughts Collection)",
      experience: "Experience Guide",
      paintings: "Paintings",
      photographs: "Photography",
      sounds: "Sounds",
      celebration: "Celebration"
    },
    search: {
      placeholder: "Search works (title, description, tags…)",
      noResults: "No matching works found",
      resultsTitle: "Search Results"
    },
    footer: {
      quote: "Thank you for coming to see my worldview, my novels, my anime, my games",
      copyright: "All Rights Reserved"
    },
    actions: {
      back: "Back to Portfolio",
      backToTop: "Back to Top",
      viewProject: "Visit Project",
      click: "Click to Visit",
      explore: "Click to Explore",
      promoBadge: "Promo",
      prev: "Previous",
      next: "Next"
    },
    sort: {
      title: "Sort by",
      byPride: "By My Favor",
      byDate: "By Date",
      date: ""
    },
    pagination: {
      page: "There's more!"
    },
    filter: {
      portfolioKind: "Work Type",
      portfolioKinds: {
        complete: "High Completeness",
        study: "Study",
        ongoing: "In Progress"
      },
      byTechnology: "Tech Stack",
      activeTag: "Active Filters",
      activeCategory: "Category",
      clearTags: "Clear tag filters",
      clearAll: "Clear all"
    }
  },
  home: {
    subtitle: "Hope everyone can find their own ideals and work for them",
    intro: "Welcome to my works experience guide. Because of my wide range of interests, I have prepared portals for different fields here. Please choose the experience route that best suits your interests.",
    conclusion: "Thank you for taking the time to experience my works. Whichever route you chose, I hope this journey has given you insight into my creative philosophy. If you have any thoughts or feedback, please feel free to share them with me."
  },
  about: {
    title: "Epitaph",
    subtitle: "Eternal Imprint in the Digital Age",
    sectionTitle: "Traces Gallery (Digital Legacy)",
    signature: "—— LuobeiLetters (formerly tobenot)",
    status: {
      private: "Private",
      archived: "Archived",
      public: "Public"
    }
  },
  project: {
    aboutWork: "About This Work",
    tags: "Tags",
    promoCta: "Learn More · Promo Page",
    filterByTag: "View works tagged with {tag}",
    category: {
      all: "All",
      vrchat: "VRChat Creations",
      novel: "Novels & Worldview",
      ai: "AI-Native Games",
      game: "Indie Games",
      tool: "Tools & Experiments",
      video: "Videos / Podcasts",
      blog: "Know the Author"
    },
    categoryDesc: {
      all: "Browse all works and explore at your own pace.",
      vrchat: "Social, reading, and experimental spaces I've built in VRChat.",
      novel: "Calm your mind and read the text universes and stories I've built.",
      ai: "Interactive experiences combining LLM with game mechanics.",
      game: "Traditional indie games, including action shooters.",
      tool: "Experience practical web tools I developed to solve actual needs.",
      video: "Sharing my creative process and thoughts through videos and podcasts.",
      blog: "If you want to know who I am, how I think, and what traces I've left behind."
    },
    metadata: {
      date: "Date",
      engine: "Engine",
      platform: "Platform",
      scale: "Scale",
      roles: "Roles",
      status: "Status",
      kind: "Type",
      experienceable: "Access"
    },
    developerNotes: "Developer Notes",
    achievements: "Milestones & Stats",
    series: "In This Series",
    seriesCurrent: "Current",
    celebrationLink: "Exhibited at {title}",
    backToCelebration: "Back to {title}",
    statusBadge: {
      experienceable: "Playable"
    },
    experienceable: {
      yes: "Playable",
      no: "Not playable"
    },
    portfolioKind: {
      study: "Study"
    },
    status: {
      released: "Released",
      development: "In Development",
      halted: "On Hold",
      archived: "Archived",
      concept: "Draft",
      private: "Private",
      // Legacy compatibility
      playable: "Playable",
      unplayable: "Unplayable",
      video: "Video",
      tool: "Tool",
      reading: "Reading"
    }
  },
  experience: {
    title: "Experience Guide",
    subtitle: "Multi-dimensional creative slices, choose your own experience route",
    feedback: "Feedback & Contact"
  },
  gallery: {
    title: "Gallery",
    description: "A collection of my paintings and photography works, capturing beautiful moments in life",
    noGallery: "No gallery works available",
    notFound: "Work not found"
  },
  paintings: {
    title: "Paintings",
    description: "A showcase of my painting creations, capturing the colors of the mind",
    noPaintings: "No paintings available",
    backToList: "Back to Paintings"
  },
  photographs: {
    title: "Photography",
    description: "Moments captured through the lens, freezing time and light",
    noPhotographs: "No photographs available",
    backToList: "Back to Photography"
  },
  sounds: {
    title: "Sounds",
    description: "This is my sound creation space, recording music and sounds",
    backToList: "Back to Sounds",
    listen: "Listen",
    play: "Play",
    pause: "Pause",
    lyrics: "Lyrics",
    noLyrics: "(No lyrics)",
    noSounds: "No audio works available"
  },
  celebration: {
    notFound: "Celebration not found.",
    missingBooth: "Booth project \"{slug}\" is missing or not configured."
  }
} 